/* 077 Plus (Ausbau 10.10.2026 abends): Mein Setup, Vergleichen, Versand-Uhr, Abholstatus,
   Als Bild teilen, Zeitangaben („vor 3 Std.“), Retro-Sounds, Zuletzt angesehen.
   Wie g077-extra.js: jedes Modul prueft selbst, ob es auf der Seite gebraucht wird; ohne JavaScript
   bleibt alles benutzbar. Keine Daten verlassen den Browser (Merkliste, Setup, Verlauf: localStorage).
   Laeuft nach theme.js und g077-extra.js (defer-Reihenfolge) und nutzt G077.compat / G077.loadIndex. */
(function () {
  'use strict';
  const G = window.G077 || {};
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const store = {
    get(k, d) { try { const v = localStorage.getItem(k); return v == null ? d : JSON.parse(v); } catch (_) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (_) { /* privater Modus */ } }
  };
  const session = {
    get(k, d) { try { const v = sessionStorage.getItem(k); return v == null ? d : JSON.parse(v); } catch (_) { return d; } },
    set(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (_) {} }
  };
  const esc = (v) => String(v == null ? '' : v).replace(/[&<>"']/g, (c) => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]));
  const toast = (msg, ms) => {
    let t = $('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._t); t._t = setTimeout(() => t.classList.remove('is-on'), ms || 2600);
  };
  const loadIndex = () => (typeof G.loadIndex === 'function' ? G.loadIndex() : Promise.resolve([]));
  const compat = (konsole, plat) => (typeof G.compat === 'function' ? G.compat(konsole, plat) : null);

  /* Berliner Zeit, unabhaengig von der Zeitzone des Geraets */
  const berlin = (date) => {
    try {
      const parts = new Intl.DateTimeFormat('de-DE', {timeZone: 'Europe/Berlin', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false}).formatToParts(date || new Date());
      const get = (t) => (parts.find((p) => p.type === t) || {}).value || '';
      const wd = {'So.': 0, 'Mo.': 1, 'Di.': 2, 'Mi.': 3, 'Do.': 4, 'Fr.': 5, 'Sa.': 6, 'So': 0, 'Mo': 1, 'Di': 2, 'Mi': 3, 'Do': 4, 'Fr': 5, 'Sa': 6}[get('weekday')];
      const h = Number(get('hour')) % 24, m = Number(get('minute'));
      if (wd == null || isNaN(h) || isNaN(m)) throw new Error('tz');
      return {wd, min: h * 60 + m};
    } catch (_) {
      const d = date || new Date();
      return {wd: d.getDay(), min: d.getHours() * 60 + d.getMinutes()};
    }
  };
  const TAGE = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
  const hhmm = (s) => { const m = /^(\d{1,2})[:.](\d{2})$/.exec(String(s || '').trim()); if (!m) return null; const h = Number(m[1]), mi = Number(m[2]); if (h > 24 || mi > 59 || (h === 24 && mi > 0)) return null; return h * 60 + mi; };
  const fmt = (min) => `${String(Math.floor(min / 60)).padStart(2, '0')}:${String(min % 60).padStart(2, '0')}`;

  /* ------------------------------------------------------------ Zeitangaben */
  /* <time data-ago="2026-10-09T12:00:00+02:00"> -> „vor 3 Std.“, „gestern“, „vor 4 Tagen“ */
  const isoFix = (s) => String(s || '').replace(/([+-]\d\d)(\d\d)$/, '$1:$2');
  const ago = (iso) => {
    const t = Date.parse(isoFix(iso)); if (isNaN(t)) return '';
    const s = Math.max(0, (Date.now() - t) / 1000);
    if (s < 3600) return 'gerade eben';
    if (s < 86400) { const h = Math.floor(s / 3600); return `vor ${h} Std.`; }
    const d = Math.floor(s / 86400);
    if (d === 1) return 'gestern';
    if (d < 14) return `vor ${d} Tagen`;
    if (d < 60) return `vor ${Math.floor(d / 7)} Wochen`;
    return new Date(t).toLocaleDateString('de-DE', {day: 'numeric', month: 'long'});
  };
  const agoSync = (root) => $$('[data-ago]', root).forEach((el) => { const s = ago(el.dataset.ago); if (s) el.textContent = s; });
  agoSync();
  /* <span data-age-since="2000-11-24"> -> „vor 25 Jahren“ (Konsolen-Steckbrief) */
  $$('[data-age-since]').forEach((el) => {
    const t = Date.parse(el.dataset.ageSince); if (isNaN(t)) return;
    const y = Math.floor((Date.now() - t) / (365.25 * 86400000));
    if (y >= 1) el.textContent = `vor ${y} Jahr${y === 1 ? '' : 'en'}`;
  });

  /* ------------------------------------------------------------ Versand-Uhr */
  /* „Bestell in den naechsten 2 Std. 14 Min., dann geht das Paket in der Regel heute raus.“
     Annahmeschluss und Versandtage aus den Theme-Einstellungen; Zeit immer Berlin.
     Der Warenkorb-Drawer wird nach jeder Aenderung komplett neu gezeichnet (theme.js renderCart) - darum als Funktion,
     die theme.js ueber „g077:cart-render“ erneut anstossen kann; alte Uhren auf abgehaengten Knoten raeumen sich selbst auf. */
  const everyTick = (fn, ms, el) => { fn(); const id = setInterval(() => { if (!el.isConnected) { clearInterval(id); return; } fn(); }, ms); };
  const initClocks = (root) => {
  $$('[data-shipclock]', root).forEach((el) => {
    if (el.g077Clock) return; el.g077Clock = true;
    const cutoff = hhmm(el.dataset.cutoff);
    const days = String(el.dataset.days || '1,2,3,4,5').split(',').map((d) => d.trim()).filter((d) => /^[0-6]$/.test(d)).map(Number);
    if (cutoff == null || !days.length) { el.hidden = true; return; }
    const out = $('[data-shipclock-text]', el) || el;
    const tick = () => {
      const now = berlin();
      if (days.indexOf(now.wd) > -1 && now.min < cutoff) {
        const rest = cutoff - now.min, h = Math.floor(rest / 60), m = rest % 60;
        const span = h > 0 ? `${h} Std. ${m} Min.` : `${m} Min.`;
        out.innerHTML = `Bestellung in den nächsten <b>${span}</b>: Paket geht in der Regel <b>noch heute</b> raus.`;
        el.classList.add('is-today');
        return;
      }
      el.classList.remove('is-today');
      let n = 1; while (n <= 7 && days.indexOf((now.wd + n) % 7) < 0) n++;
      const wann = n === 1 ? 'morgen' : `am ${TAGE[(now.wd + n) % 7]}`;
      /* Kein Versandtag (z. B. Wochenende): nicht „Annahmeschluss vorbei“ behaupten */
      out.innerHTML = days.indexOf(now.wd) < 0 ? `Heute kein Versandtag: Bestellungen gehen <b>${wann}</b> raus.` : `Annahmeschluss ${fmt(cutoff)} Uhr ist vorbei: Bestellungen gehen <b>${wann}</b> raus.`;
    };
    everyTick(tick, 30000, el);
    el.hidden = false;
  });

  /* ------------------------------------------------------------ Abholstatus */
  /* data-times="1-5:10:00-18:00;6:10:00-14:00" (Wochentage 0=So … 6=Sa) */
  const parseTimes = (s) => {
    const rows = [];
    String(s || '').split(';').forEach((part) => {
      const m = /^\s*([0-6])(?:-([0-6]))?\s*:\s*(\d{1,2}[:.]\d{2})\s*-\s*(\d{1,2}[:.]\d{2})\s*$/.exec(part);
      if (!m) return;
      const a = Number(m[1]), b = m[2] ? Number(m[2]) : a, von = hhmm(m[3]), bis = hhmm(m[4]);
      if (von == null || bis == null) return;
      for (let d = a; d <= b; d++) rows.push({wd: d % 7, von, bis});
    });
    return rows;
  };
  $$('[data-pickup-live]', root).forEach((el) => {
    if (el.g077Clock) return; el.g077Clock = true;
    const rows = parseTimes(el.dataset.times);
    if (!rows.length) return;
    const place = el.dataset.place || 'unserem Standort';
    const out = $('[data-pickup-text]', el) || el;
    // Gleiche Zusage wie Pflichtangaben und FAQ: bereit in der Regel nach 24 Stunden
    const BEREIT = 'Abholung kostenlos, im Checkout wählbar; Bestellungen liegen in der Regel nach 24 Stunden bereit.';
    const tick = () => {
      const now = berlin();
      const heute = rows.filter((r) => r.wd === now.wd);
      const offen = heute.find((r) => now.min >= r.von && now.min < r.bis);
      el.classList.toggle('is-open', !!offen);
      if (offen) { out.innerHTML = `Abholzeiten in ${esc(place)}: <b>heute bis ${fmt(offen.bis)} Uhr</b>. ${BEREIT}`; return; }
      const spaeter = heute.filter((r) => now.min < r.von).sort((a, b) => a.von - b.von)[0];
      if (spaeter) { out.innerHTML = `Abholzeiten in ${esc(place)}: <b>heute ab ${fmt(spaeter.von)} Uhr</b>. ${BEREIT}`; return; }
      for (let n = 1; n <= 7; n++) {
        const wd = (now.wd + n) % 7;
        const r = rows.filter((x) => x.wd === wd).sort((a, b) => a.von - b.von)[0];
        if (r) { out.innerHTML = `Abholzeiten in ${esc(place)}: wieder <b>${n === 1 ? 'morgen' : 'am ' + TAGE[wd]} ab ${fmt(r.von)} Uhr</b>. ${BEREIT}`; return; }
      }
    };
    everyTick(tick, 60000, el);
    el.hidden = false;
    /* Die feste Abhol-Zeile daneben ausblenden, sonst steht „Abholung in …“ zweimal untereinander */
    const fest = el.parentElement && $('[data-pickup-static]', el.parentElement);
    if (fest) fest.hidden = true;
  });
  /* Abholwunsch: ab morgen 7 Tage in Stundenfenstern aus data-times, mindestens 24 Std. Vorlauf (wie BEREIT oben);
     Auswahl sofort im Warenkorb speichern, ein vergangener Wunsch wird verworfen */
  $$('[data-pickup-slot]', root).forEach((el) => {
    if (el.g077Slot) return; el.g077Slot = true;
    const sel = $('[data-pickup-slot-select]', el), rows = parseTimes(el.dataset.times);
    if (!sel || !rows.length) return;
    const cur = el.dataset.current || '';
    const now = berlin(), nowDate = new Date();
    const dfmt = new Intl.DateTimeFormat('de-DE', {timeZone: 'Europe/Berlin', weekday: 'short', day: '2-digit', month: '2-digit'});
    const dlong = new Intl.DateTimeFormat('de-DE', {timeZone: 'Europe/Berlin', weekday: 'long', day: '2-digit', month: '2-digit', year: 'numeric'});
    const opts = [];
    for (let n = 1; n <= 7 && opts.length < 40; n++) {
      const date = new Date(nowDate.getTime() + n * 86400000), wd = (now.wd + n) % 7;
      rows.filter((r) => r.wd === wd).sort((a, b) => a.von - b.von).forEach((r) => {
        for (let t = r.von; t + 60 <= r.bis; t += 60) {
          if (n === 1 && t < now.min) continue;
          opts.push({value: `${dlong.format(date)} ${fmt(t)}–${fmt(t + 60)} Uhr`, label: `${dfmt.format(date)} ${fmt(t)}–${fmt(t + 60)} Uhr`});
        }
      });
    }
    if (!opts.length) return;
    opts.forEach((o) => { const op = document.createElement('option'); op.value = o.value; op.textContent = o.label; if (o.value === cur) op.selected = true; sel.appendChild(op); });
    /* „Montag, 12.10.2026 17:00–18:00 Uhr“: liegt der Beginn schon zurueck, nicht wieder vorwaehlen und am Warenkorb loeschen */
    const cm = /(\d{2})\.(\d{2})\.(\d{4}) (\d{2}):(\d{2})/.exec(cur);
    const vorbei = !!cm && new Date(+cm[3], cm[2] - 1, +cm[1], +cm[4], +cm[5]) < nowDate;
    if (vorbei && G.routes && G.routes.cart) fetch(`${G.routes.cart}/update.js`, {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({attributes: {Abholwunsch: ''}})}).catch(() => {});
    if (cur && sel.value !== cur && !vorbei) { const op = document.createElement('option'); op.value = cur; op.textContent = cur; op.selected = true; sel.appendChild(op); }
    sel.addEventListener('change', () => {
      if (!G.routes || !G.routes.cart) return;
      fetch(`${G.routes.cart}/update.js`, {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({attributes: {Abholwunsch: sel.value}})})
        .then((r) => { if (r.ok) toast(sel.value ? 'Abholwunsch gespeichert' : 'Abholwunsch entfernt'); })
        .catch(() => { /* Formular traegt den Wert beim Klick auf „Zur Kasse“ trotzdem mit */ });
    });
    el.hidden = false;
  });
  };
  initClocks(document);
  document.addEventListener('g077:cart-render', (e) => initClocks((e.detail && e.detail.root) || document));

  /* ------------------------------------------------------------ Mein Setup */
  /* Welche Konsolen hat der Kunde zu Hause? Liste im Browser; Karten bekommen „Passt zu deiner PS2“,
     der Shop-Filter (077-shop.js) kann auf passende Spiele/Zubehoer einschraenken, der Kompatibilitaets-
     Check auf der Produktseite ist vorbelegt. */
  const SETUP = 'g077-setup';
  /* Zwischengespeichert: der Shop-Filter fragt je Artikel und Zaehler (G077.fits), nicht jedes Mal localStorage lesen */
  let setupCache = null;
  const setupList = () => setupCache || (setupCache = (() => { const v = store.get(SETUP, []); return (Array.isArray(v) ? v : []).filter((x) => typeof x === 'string').slice(0, 12); })());
  window.addEventListener('storage', (e) => { if (e.key === SETUP || e.key === null) setupCache = null; });
  const fits = (plat, kind) => {
    const l = setupList(); if (!l.length) return null;
    if (kind && kind !== 'game' && kind !== 'accessory') return null;
    /* Zubehoer passt nur zur eigenen Plattform; die Disc-Tabelle gilt fuer Spiele */
    if (kind === 'accessory') { const k = l.find((x) => x === plat || (/^(Xbox Series|Game Boy)$/.test(plat) && x.indexOf(plat) === 0)); return k ? {s: 'ja', k} : null; }
    let best = null;
    l.forEach((k) => {
      const r = compat(k, plat); if (!r) return;
      if (r.s === 'ja') best = best && best.s === 'ja' ? best : {s: 'ja', k};
      else if (r.s === 'teils' && !best) best = {s: 'teils', k};
    });
    return best;
  };
  G.setup = setupList;
  G.fits = (plat, kind) => { const r = fits(plat, kind); return !!(r && r.s === 'ja'); };
  const markSetup = (root) => {
    $$('.card[data-plat]', root).forEach((card) => {
      const old = $('.card__fit', card); if (old) old.remove();
      const r = fits(card.dataset.plat, card.dataset.kind);
      if (!r) return;
      const body = $('.card__body', card); if (!body) return;
      const tag = document.createElement('p');
      tag.className = 'card__fit' + (r.s === 'teils' ? ' card__fit--teils' : '');
      const ihrer = typeof G.derKonsole === 'function' && G.derKonsole(r.k) ? 'deinem' : 'deiner';
      tag.textContent = r.s === 'ja' ? `Passt zu ${ihrer} ${r.k}` : `Läuft teils auf ${ihrer} ${r.k}`;
      const foot = $('.card__foot', body);
      if (foot) body.insertBefore(tag, foot); else body.appendChild(tag);
    });
  };
  const setupSync = () => {
    const l = setupList();
    $$('[data-setup-box] input[type=checkbox]').forEach((c) => { c.checked = l.indexOf(c.value) > -1; });
    $$('[data-setup-count]').forEach((c) => { c.textContent = l.length; c.hidden = !l.length; });
    $$('[data-setup-summary]').forEach((s) => { s.textContent = l.length ? l.join(' · ') : 'Noch keine Konsole gewählt'; });
    markSetup(document);
    document.dispatchEvent(new CustomEvent('g077:setup', {detail: l}));
  };
  $$('[data-setup-box]').forEach((box) => {
    box.addEventListener('change', (e) => {
      const c = e.target; if (!c.matches('input[type=checkbox]')) return;
      let l = setupList().slice();
      if (c.checked && l.indexOf(c.value) < 0) l.push(c.value);
      if (!c.checked) l = l.filter((x) => x !== c.value);
      store.set(SETUP, l); setupCache = null;
      /* Kompatibilitaets-Check auf Produktseiten mit der ersten Konsole vorbelegen */
      if (l.length && !store.get('g077-console', '')) store.set('g077-console', l[0]);
      setupSync();
      const lbl = c.closest('label'); const name = (lbl && lbl.querySelector('span') ? lbl.querySelector('span').textContent : c.value).trim();
      toast(c.checked ? `${name} zu deinem Setup hinzugefügt` : `${name} aus deinem Setup entfernt`);
    });
    const clear = $('[data-setup-clear]', box);
    if (clear) clear.addEventListener('click', () => { store.set(SETUP, []); setupCache = null; setupSync(); });
  });
  if (setupList().length) {
    /* Produktseite: Auswahl im „Laeuft das bei dir?“ vorbelegen, falls dort noch nichts gewaehlt ist */
    $$('[data-compat-select]').forEach((sel) => {
      if (sel.value) return;
      const k = setupList().find((x) => $$('option', sel).some((o) => o.value === x));
      if (k) { sel.value = k; sel.dispatchEvent(new Event('change', {bubbles: true})); }
    });
  }
  setupSync();
  document.addEventListener('g077:grid', (e) => { markSetup(e.detail || document); agoSync(e.detail || document); cmpSync(); });

  /* ------------------------------------------------------------ Vergleichen */
  /* Bis zu drei Artikel nebeneinander: Zustand, Preis, CHECK, Lieferumfang. Auswahl in sessionStorage. */
  const CMP = 'g077-cmp';
  const cmpList = () => { const v = session.get(CMP, []); return (Array.isArray(v) ? v : []).filter((x) => x && typeof x.h === 'string').slice(0, 3); };
  const bar = $('[data-cmp-bar]');
  function cmpSync() {
    const l = cmpList();
    $$('[data-cmp]').forEach((b) => { const on = l.some((x) => x.h === b.dataset.cmp); b.setAttribute('aria-pressed', String(on)); b.classList.toggle('is-on', on); const lab = $('[data-cmp-label]', b); if (lab) lab.textContent = on ? 'Im Vergleich' : 'Vergleichen'; });
    if (bar) {
      bar.hidden = !l.length;
      const chips = $('[data-cmp-chips]', bar);
      if (chips) chips.innerHTML = l.map((x) => `<button type="button" class="chip cmpbar__chip" data-cmp-remove="${esc(x.h)}" aria-label="${esc(x.t)} aus dem Vergleich entfernen">${esc(x.t)}<span aria-hidden="true">×</span></button>`).join('');
      const n = $('[data-cmp-n]', bar); if (n) n.textContent = l.length;
      const go = $('[data-open="compare"]', bar); if (go) go.disabled = l.length < 2;
    }
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-cmp]');
    if (b) {
      e.preventDefault(); e.stopPropagation();
      let l = cmpList();
      const h = b.dataset.cmp, on = l.some((x) => x.h === h);
      if (on) l = l.filter((x) => x.h !== h);
      else if (l.length >= 3) { toast('Maximal drei Artikel im Vergleich'); return; }
      else l.push({h, t: b.dataset.cmpTitle || h});
      session.set(CMP, l); cmpSync();
      toast(on ? 'Aus dem Vergleich entfernt' : (l.length < 2 ? 'Im Vergleich. Noch einen Artikel dazu wählen.' : `${l.length} Artikel im Vergleich`));
      return;
    }
    const r = e.target.closest('[data-cmp-remove]');
    if (r) { session.set(CMP, cmpList().filter((x) => x.h !== r.dataset.cmpRemove)); cmpSync(); return; }
    if (e.target.closest('[data-cmp-clear]')) { session.set(CMP, []); cmpSync(); }
  });
  const cmpBody = $('[data-cmp-table]');
  if (cmpBody) {
    const checkText = (it) => it.strict ? 'Bestanden' : (it.ok ? 'Mit Hinweis' : 'Unvollständig');
    const render = (items) => {
      const rows = cmpList().map((x) => items.find((it) => it.handle === x.h)).filter(Boolean);
      if (rows.length < 2) { cmpBody.innerHTML = (typeof G.indexFailed === 'function' && G.indexFailed()) ? '<p class="cmp__empty">Der Bestand konnte gerade nicht geladen werden. Bitte später noch einmal öffnen.</p>' : '<p class="cmp__empty">Mindestens zwei Artikel auswählen, dann stehen sie hier nebeneinander.</p>'; return; }
      const minPrice = Math.min.apply(null, rows.filter((r) => r.available).map((r) => r.price));
      const maxLvl = Math.max.apply(null, rows.map((r) => Number(r.lvl) || 0));
      const cell = (fn, cls) => rows.map((r) => `<td${cls ? ` class="${cls(r)}"` : ''}>${fn(r)}</td>`).join('');
      cmpBody.innerHTML = `<table class="cmp"><thead><tr><th scope="row"><span class="visually-hidden">Artikel</span></th>${rows.map((r) => `<th scope="col"><a class="cmp__item" href="${esc(r.url)}">${r.img ? `<img src="${esc(r.img)}" alt="" loading="lazy">` : `<span class="cmp__noimg cmp__noimg--art">${G.coverHTML(r)}</span>`}<span>${esc(r.title)}</span></a></th>`).join('')}</tr></thead><tbody>
        <tr><th scope="row">Plattform</th>${cell((r) => esc(r.plat))}</tr>
        <tr><th scope="row">Zustand</th>${cell((r) => `<span class="cmp__grade" style="--lvl:${Number(r.lvl) || 0}%"><b>${esc(r.grade || '–')}</b><i aria-hidden="true"><em></em></i></span>`, (r) => (Number(r.lvl) || 0) === maxLvl ? 'is-best' : '')}</tr>
        <tr><th scope="row">Preis</th>${cell((r) => r.available ? `<b>${esc(r.priceText)}</b>` : `<s>${esc(r.priceText)}</s>`, (r) => r.available && r.price === minPrice ? 'is-best' : '')}</tr>
        <tr><th scope="row">077 CHECK</th>${cell((r) => `<span class="cmp__check cmp__check--${r.strict ? 'ok' : (r.ok ? 'note' : 'none')}">${checkText(r)}</span>`)}</tr>
        <tr><th scope="row">Lieferumfang</th>${cell((r) => esc(r.scope || (r.kind === 'game' ? 'Siehe Protokoll' : '–')))}</tr>
        <tr><th scope="row">077-ID</th>${cell((r) => `<span class="cmp__id">${esc(r.id || '–')}</span>`)}</tr>
        <tr><th scope="row">Verfügbar</th>${cell((r) => r.available ? (r.drop === 'locked' ? 'Drop, bald' : 'Ja, Einzelstück') : 'Verkauft')}</tr>
        <tr><th scope="row"><span class="visually-hidden">Aktion</span></th>${cell((r) => `<a class="btn btn--sm${r.available ? '' : ' btn--ghost'}" href="${esc(r.url)}"><span>${r.available ? 'Ansehen' : 'Details'}</span></a>`)}</tr>
      </tbody></table>`;
    };
    document.addEventListener('g077:drawer', (e) => {
      if (!e.detail || e.detail.name !== 'compare') return;
      cmpBody.innerHTML = '<p class="cmp__empty">Vergleich wird geladen …</p>';
      loadIndex().then(render);
    });
    document.addEventListener('click', (e) => { if (e.target.closest('[data-cmp-remove],[data-cmp-clear]') && $('[data-drawer="compare"].is-open')) loadIndex().then(render); });
  }
  cmpSync();

  /* ------------------------------------------------------------ Als Bild teilen */
  /* Produktkarte als PNG (1080x1350) mit Titel, Zustand, Preis, 077-ID und Adresse. Teilen ueber den
     Teilen-Dialog des Geraets (WhatsApp, Instagram …), sonst Download. Bild wird lokal im Browser gezeichnet. */
  const loadImg = (src) => new Promise((res) => { if (!src) return res(null); const i = new Image(); i.crossOrigin = 'anonymous'; i.onload = () => res(i); i.onerror = () => res(null); i.src = src; });
  const wrapText = (ctx, text, max, maxLines) => {
    const words = String(text || '').split(/\s+/), lines = []; let line = '';
    words.forEach((w) => { const t = line ? line + ' ' + w : w; if (ctx.measureText(t).width > max && line) { lines.push(line); line = w; } else line = t; });
    if (line) lines.push(line);
    if (lines.length > maxLines) { lines.length = maxLines; lines[maxLines - 1] = lines[maxLines - 1].replace(/\s*\S*$/, '') + ' …'; }
    return lines;
  };
  const roundRect = (ctx, x, y, w, h, r) => { ctx.beginPath(); ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r); ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath(); };
  const tok = (n, f) => getComputedStyle(document.documentElement).getPropertyValue(n).trim() || f;
  const drawCard = async (d) => {
    const T = {bg: tok('--bg', '#0a0a0a'), fg: tok('--fg', '#f4f2ec'), mu: tok('--muted', '#b1b1b1'), su: tok('--surface', '#161616'), ln: tok('--line', '#2e2e2e'), wh: tok('--white', '#fff'), ok: tok('--ok', '#4ade80')};
    const W = 1080, H = 1350, c = document.createElement('canvas'); c.width = W; c.height = H;
    const ctx = c.getContext('2d'); if (!ctx) return null;
    const ff = '"Inter", "Helvetica Neue", Arial, sans-serif';
    try { if (document.fonts && document.fonts.load) await Promise.all([document.fonts.load(`800 60px ${ff}`), document.fonts.load(`600 30px ${ff}`)]); } catch (_) {}
    ctx.fillStyle = T.bg; ctx.fillRect(0, 0, W, H);
    ctx.fillStyle = T.fg; ctx.font = `800 44px ${ff}`; ctx.fillText('077 STUDIO', 72, 110);
    ctx.font = `600 24px ${ff}`; ctx.fillStyle = T.mu; ctx.fillText('EINZELSTÜCK · MIT PRÜFSTATUS', 72, 152);
    /* Bild oder Plattform-Flaeche */
    const img = await loadImg(d.img);
    const bx = 72, by = 200, bw = W - 144, bh = 640;
    ctx.save(); roundRect(ctx, bx, by, bw, bh, 24); ctx.clip();
    ctx.fillStyle = T.su; ctx.fillRect(bx, by, bw, bh);
    if (img) {
      const s = Math.min(bw / img.width, bh / img.height) * 0.92;
      const iw = img.width * s, ih = img.height * s;
      ctx.drawImage(img, bx + (bw - iw) / 2, by + (bh - ih) / 2, iw, ih);
    } else {
      ctx.fillStyle = tok('--pc-' + G.famOf(G.handleize(d.plat)), '#3a3a3a'); ctx.fillRect(bx, by, bw, 90);
      ctx.fillStyle = T.wh; ctx.font = `800 40px ${ff}`; ctx.fillText(String(d.plat || ''), bx + 36, by + 60);
      ctx.fillStyle = T.fg; ctx.font = `800 84px ${ff}`;
      wrapText(ctx, d.title, bw - 72, 4).forEach((l, i) => ctx.fillText(l, bx + 36, by + 250 + i * 96));
    }
    ctx.restore();
    /* Text */
    let y = 920;
    ctx.fillStyle = T.fg; ctx.font = `800 56px ${ff}`;
    wrapText(ctx, d.title, W - 144, 2).forEach((l) => { ctx.fillText(l, 72, y); y += 66; });
    ctx.fillStyle = T.mu; ctx.font = `600 30px ${ff}`;
    ctx.fillText([d.plat, d.grade && d.grade !== 'Ungeprüft' ? `Zustand ${d.grade}` : '', d.id ? `077-ID ${d.id}` : ''].filter(Boolean).join('  ·  '), 72, y + 10); y += 70;
    /* Zustandsbalken */
    const lvl = Math.max(0, Math.min(100, Number(d.lvl) || 0));
    roundRect(ctx, 72, y, 420, 10, 5); ctx.fillStyle = T.ln; ctx.fill();
    roundRect(ctx, 72, y, 420 * lvl / 100, 10, 5); ctx.fillStyle = T.fg; ctx.fill(); y += 60;
    ctx.fillStyle = T.fg; ctx.font = `800 64px ${ff}`; ctx.fillText(d.price || '', 72, y + 30);
    if (d.check) {
      const lab = d.check === 'ok' ? '077 CHECK · BESTANDEN' : (d.check === 'note' ? '077 CHECK · MIT HINWEIS' : 'UNGEPRÜFT');
      ctx.font = `800 24px ${ff}`; const tw = ctx.measureText(lab).width + 48;
      roundRect(ctx, W - 72 - tw, y - 16, tw, 56, 28); ctx.strokeStyle = d.check === 'ok' ? T.ok : T.fg; ctx.lineWidth = 3; ctx.stroke();
      ctx.fillStyle = d.check === 'ok' ? T.ok : T.fg; ctx.fillText(lab, W - 72 - tw + 24, y + 22);
    }
    ctx.fillStyle = T.mu; ctx.font = `600 28px ${ff}`; ctx.fillText(String(d.site || '077-gaming.de'), 72, H - 72);
    return c;
  };
  $$('[data-share]').forEach((btn) => {
    btn.hidden = false;
    btn.addEventListener('click', async () => {
      const d = btn.dataset;
      const url = d.shareUrl || location.href;
      btn.disabled = true; btn.classList.add('is-busy');
      try {
        const daten = {title: d.shareTitle, plat: d.sharePlat, grade: d.shareGrade, lvl: d.shareLvl, id: d.shareId, price: d.sharePrice, check: d.shareCheck, img: d.shareImg, site: d.shareSite};
        const toBlob = (c) => new Promise((res, rej) => { try { c.toBlob((b) => (b ? res(b) : rej(new Error('blob'))), 'image/png'); } catch (e) { rej(e); } });
        let c = await drawCard(daten), blob = null;
        try { blob = c ? await toBlob(c) : null; } catch (_) {
          /* Bild vom CDN ohne CORS-Freigabe macht die Zeichenflaeche unlesbar: dann ohne Foto zeichnen */
          c = await drawCard(Object.assign({}, daten, {img: ''}));
          try { blob = c ? await toBlob(c) : null; } catch (__) { blob = null; }
        }
        const file = blob && typeof File === 'function' ? new File([blob], `077-${(d.shareId || 'artikel').replace(/[^\w-]+/g, '-')}.png`, {type: 'image/png'}) : null;
        const text = `${d.shareTitle || ''} – ${d.sharePrice || ''} im Test Shop von 077 Studio`;
        if (file && navigator.canShare && navigator.canShare({files: [file]})) { await navigator.share({files: [file], title: d.shareTitle || '', text, url}); return; }
        if (navigator.share) { await navigator.share({title: d.shareTitle || '', text, url}); return; }
        if (blob) { const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = file ? file.name : '077.png'; document.body.appendChild(a); a.click(); a.remove(); setTimeout(() => URL.revokeObjectURL(a.href), 2000); }
        try { await navigator.clipboard.writeText(url); toast('Bild gespeichert, Link kopiert'); } catch (_) { toast('Bild gespeichert'); }
      } catch (err) {
        if (!(err && err.name === 'AbortError')) toast('Teilen hat nicht geklappt');
      } finally { btn.disabled = false; btn.classList.remove('is-busy'); }
    });
  });

  /* ------------------------------------------------------------ Retro-Sounds */
  /* Kurze 8-Bit-Toene bei Warenkorb, Merkliste und Vergleich. Standard: aus. Erzeugt im Browser, keine Dateien. */
  const SND = 'g077-sound';
  let actx = null;
  const soundOn = () => !!store.get(SND, false);
  const beep = (notes) => {
    if (!soundOn()) return;
    try {
      const AC = window.AudioContext || window.webkitAudioContext; if (!AC) return;
      actx = actx || new AC();
      if (actx.state === 'suspended') actx.resume();
      let t = actx.currentTime;
      notes.forEach(([f, dur]) => {
        const o = actx.createOscillator(), g = actx.createGain();
        o.type = 'square'; o.frequency.value = f;
        g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(0.08, t + 0.01); g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
        o.connect(g); g.connect(actx.destination); o.start(t); o.stop(t + dur + 0.02); t += dur;
      });
    } catch (_) {}
  };
  const soundSync = () => $$('[data-sound-toggle]').forEach((b) => { const on = soundOn(); b.setAttribute('aria-pressed', String(on)); const l = $('[data-sound-label]', b); if (l) l.textContent = on ? 'Retro-Sounds an' : 'Retro-Sounds aus'; });
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-sound-toggle]');
    if (t) { store.set(SND, !soundOn()); soundSync(); if (soundOn()) beep([[660, 0.07], [880, 0.07], [1320, 0.1]]); return; }
    if (e.target.closest('[data-wish]')) beep([[1046, 0.05], [1568, 0.08]]);
    if (e.target.closest('[data-cmp]')) beep([[784, 0.05]]);
  });
  document.addEventListener('g077:cart', (e) => { if (e.detail && e.detail.action === 'add') beep([[988, 0.06], [1319, 0.06], [1760, 0.12]]); });
  soundSync();

  /* ------------------------------------------------------------ Zuletzt angesehen */
  /* Verlauf im Browser (localStorage, 12 Handles). Die Karten kommen fertig aus Liquid:
     /products/<handle>?view=g077-card (templates/product.g077-card.liquid = product-card),
     mit aktuellem Pruefstatus, Preis und Verfuegbarkeit - kein Bestandsindex mehr. */
  const RECENT = 'g077-recent';
  const recentList = () => { const v = store.get(RECENT, []); return (Array.isArray(v) ? v : []).filter((h) => typeof h === 'string').slice(0, 12); };
  const track = $('[data-recent-track]');
  const current = track ? track.dataset.recentTrack : '';
  if (current) store.set(RECENT, [current].concat(recentList().filter((h) => h !== current)).slice(0, 12));
  $$('[data-recent]').forEach((box) => {
    const grid = $('[data-recent-grid]', box); if (!grid || !window.fetch) return;
    const list = recentList().filter((h) => h !== current).slice(0, Math.min(Number(box.dataset.recentMax) || 8, 8));
    if (!list.length) return;
    const root = ((G.routes && G.routes.root) || '/').replace(/\/$/, '');
    /* 404 (Artikel weg): Handle aus dem Verlauf; sonstiger Fehler oder Abbruch nach 8 s: Karte faellt nur diesmal weg */
    const card = (h) => fetch(`${root}/products/${encodeURIComponent(h)}?view=g077-card`, {credentials: 'same-origin', cache: 'no-store', signal: window.AbortSignal && AbortSignal.timeout ? AbortSignal.timeout(8000) : undefined})
      .then((r) => { if (r.status === 404) store.set(RECENT, recentList().filter((x) => x !== h)); return r.ok ? r.text() : ''; })
      .then((t) => (/^\s*<article class="card\b/.test(t) ? t.trim() : '')).catch(() => '');
    const load = () => Promise.all(list.map(card)).then((cards) => {
      const html = cards.filter(Boolean).map((c) => `<li>${c}</li>`).join('');
      if (!html) return; /* nichts erreichbar: Abschnitt bleibt verborgen */
      grid.innerHTML = html; box.hidden = false;
      document.dispatchEvent(new CustomEvent('g077:grid', {detail: grid})); /* Herz, Vergleich, Drop-Zaehler, „Passt zu“, Holo */
    });
    /* erst nach dem Laden der Seite: der Abschnitt steht unter dem Protokoll, Foto und Galerie haben Vorrang */
    if (document.readyState === 'complete') load(); else window.addEventListener('load', load, {once: true});
  });

})();
